import Vuex from 'vuex'
import Vue from 'vue'
import * as types from './types'

/**
 * Vuex全局状态管理
 * @param options {Array} 用于渲染tabs的数组
 */

Vue.use(Vuex);
export default new Vuex.Store({
	state: {
		user: {},
		token: '',
		options: [],
        activeIndex: '/welcome',
        userInfo: {},
        menuIndex:'0'
	},
	mutations: {
		set_token(state, token) {
			state.token = token;
            localStorage.token = token
			// state.id = data.id
		},
		del_token(state) {
			state.token = null;
            localStorage.removeItem('token')
			// state.id = null
		},
		// 添加tabs
        add_tabs (state, data) {
            this.state.options.push(data);
        },
        // 存储index
        save_index (state, data) {
            this.state.menuIndex=data?data:'0';
        },  
        // 删除tabs
        delete_tabs (state, route) {
            console.log(route)
            console.log(state)
            let index = 0;
            for (let option of state.options) {
                console.log((option.route === route))
                if (option.route === route) {
                    break;
                }
                index++;
            }
            this.state.options.splice(index, 1);
            console.log(this.state.options)
        },
        // 设置当前激活的tab
        set_active_index (state, index) {
            this.state.activeIndex = index;
        },
      
        //设置详情信息
        save_detail_info (state, info) {
            this.state.userInfo = info;
        }
	}
})



// WEBPACK FOOTER //
// ./src/store/store.js